import React, { useState, useEffect } from "react";
import { ThreeDots } from "react-loader-spinner";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import axios from "axios";
import Cookies from "js-cookie";
import { formatToDateOnly } from "../../../utils/helpers";
import { API_CSAT_RATING } from "../../../config/Endpoints";
import { useProjectDesignationOptions } from "../../../Hooks/useProjectDesignationOptions";

const CSATAddRatingModal = ({
  show,
  onFinish,
  onClose,
  selectedEmployees,
  projectId,
}) => {
  const { options: designationOptions } = useProjectDesignationOptions();
  const [isLoadingFinish, setIsLoadingFinish] = useState(false);
  const [csatRating, setCsatRating] = useState("");
  const accessToken = Cookies.get("accessToken");
  const user = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  if (!show) return null;

  const handleFinish = async () => {
    if (csatRating < 1 || csatRating > 5) {
      toast.error("CSAT Rating must be between 1 and 5.");
      return;
    }

    const payload = {
      projectId,
      employeeIds: selectedEmployees.map(
        (emp) => emp.employeeId || emp.shadowEmployeeId,
      ),
      rating: parseFloat(csatRating),
      createdBy: user?.id,
      createdAt: formatToDateOnly(new Date()),
    };

    try {
      setIsLoadingFinish(true);

      const res = await axios.post(API_CSAT_RATING, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      toast.success(res.data?.message || "CSAT submitted successfully.");

      onFinish(res.data);
    } catch (err) {
      toast.error(err.response?.data?.message || "Error submitting CSAT");
    } finally {
      setIsLoadingFinish(false);
    }
  };
  const handleCsatRatingChange = (e) => {
    const value = e.target.value;

    if (value === "" || /^(?:[1-4](?:\.\d{0,1})?|5(?:\.0?)?)$/.test(value)) {
      setCsatRating(value);
    }
  };
  const handleClose = () => {
    setCsatRating("");
    onClose();
  };

  return (
    <>
      <div className="modal fade show csat-rating-table">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content rounded-lg">
            <div className="modal-header">
              <h5 className="modal-title">Add CSAT Rating</h5>
            </div>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleFinish();
              }}
            >
              <div className="modal-body p-3">
                <div className="d-flex col-md-12 justify-content-start align-items-center">
                  <div className="d-flex align-items-center gap-3 col-md-12 ps-3">
                    <label className=" has-asterisk">CSAT Rating</label>
                    <div className="col-md-1"></div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        step="0.1"
                        min="1"
                        max="5"
                        value={csatRating}
                        onChange={handleCsatRatingChange}
                        className="border text-center"
                        placeholder="Enter CSAT Rating"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3 mt-4 ps-3">
                  <h6 className="mb-3 fw-normal ">Selected Members</h6>
                  {selectedEmployees?.length > 0 ? (
                    <div className="table-responsive csat-selected-members-table rounded-lg">
                      <table className="resume custom">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Employee Name</th>
                            <th>Designation</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedEmployees.map((member, index) => (
                            <tr key={member.employeeId || index}>
                              <td className="text-center">{index + 1}</td>
                              <td>
                                {member.employeeName
                                  ? member.employeeName
                                  : member.shadowEmployeeName
                                    ? member.shadowEmployeeName
                                    : member.fullName
                                      ? member.fullName.trim()
                                      : "—"}
                              </td>
                              <td>
                                {(() => {
                                  const specialLabels = {
                                    project_manager: "Project Manager",
                                    delivery_lead: "Delivery Lead",
                                    principal_sponsor: "Principal Sponsor",
                                    lead_business_analyst:
                                      "Lead Business Analyst",
                                  };

                                  if (
                                    specialLabels[
                                      member.designation?.toLowerCase()
                                    ]
                                  ) {
                                    return specialLabels[
                                      member.designation.toLowerCase()
                                    ];
                                  }

                                  return (
                                    designationOptions.find(
                                      (d) => d.value === member.designation,
                                    )?.label ||
                                    member.designation ||
                                    "—"
                                  );
                                })()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p className="text-muted text-center">
                      No members selected
                    </p>
                  )}
                </div>
              </div>

              <div className="modal-footer justify-content-center rounded-lg-bottom">
                <button
                  type="button"
                  className="theme-button bg-grey mx-3"
                  onClick={handleClose}
                >
                  Back
                </button>
                <button
                  type="submit"
                  className="theme-button"
                  disabled={isLoadingFinish}
                >
                  {isLoadingFinish ? (
                    <ThreeDots
                      height="20"
                      width="60"
                      radius="9"
                      color="white"
                      ariaLabel="three-dots-loading"
                      visible={true}
                    />
                  ) : (
                    "Add Rating"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default CSATAddRatingModal;
